import React from "react";
import { Button, Col, Row } from "react-bootstrap";

const Rules = () => {
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>Rules</h1>
        <Row className="mt-4">
          <p className="fs-6">
            Each person for joining the Bar Association shall submit to the
            Secretary, an application on the prescribed form along with
            photostat copy of the Registration certificate of Bar Council and
            photostat copies of mark sheet and of provision LL.B.(Professional)
            Degree or Degree LL.B. (Professional).
            <br />
            <br /> “For the enrollment of new member a three member committee
            consisting of secretary and two executive members shall be
            constituted which shall examine all necessary documents of new
            applicant for membership.
            <br />
            <br /> That for new member before applicant is enrolled and inducted
            as a member of bar Association, the applicant should have completed
            a tenure of internship/juniorship of at-least 6 months with any
            existing member of Bar Association who has been a member of Bar
            Association for ar least 10 years along with an affidavit of the
            fact that applicant is not a member of any other Bar Association
            except Bar Association of High Court at Nainital. Particulars of
            such applicants shall be circulated by the Secretary amongst members
            and shall be displayed in member register of Bar Association,
            Dehradun along with photograph of such applicant. After having
            completed a period of 6 months internship/junior-ship the applicant
            shall furnish the certificate of such internship/junior-ship
            regarding the working and conduct of the applicant which shall again
            be examined accordingly and thereafter the membership of Bar
            Association shall be granted by the Secretary. For seeking financial
            assistance it is necessary for the applicant to be primarily, a
            member of Bar Association, Dehradun.
            <br />
            <br /> It is desirable for any member of Bar Association Dehradun to
            become member of Bar Association of High Court at Nainital. But in
            case such a member with dual membership, exercising the right of
            voting in the Bar Association of High Court at Nainital, shall lose
            the right of financial assistance from Bar Association, Dehradun.
            All other members with dual membership i.e. one of Bar Association
            Dehradun and the other of any other Bar Association except Bar
            Association of High Court at Nainital shall also not be entitled to
            any financial assistance form Bar Association Dehradun. <br />
            Any member of Bar Association Dehradun with dual membership, the
            other being the membership of Bar Association of High Court at
            Nainital, shall exercise the right of voting in only one of the
            above two Bar Association. But the member with such dual membership
            opting to exercise to the voting right in Bar Association of High
            Court at Nainital shall also not be entitled to any financial
            assistance form Bar Association, Dehradun. The Executive Committee
            shall be competent to inquire the matter of indiscipline and if need
            be such erring member can be called by the Executive Committee for
            clarification and after enquiry its report shall be tabled in
            general house meeting for necessary action. Any convicted person
            shall not be eligible to become member of Bar Association, Dehradun.
          </p>
        </Row>
      </section>
    </>
  );
};

export default Rules;
